import { render, staticRenderFns } from "./UserMenuInfo.vue?vue&type=template&id=15c9981b&scoped=true&"
import script from "./UserMenuInfo.vue?vue&type=script&lang=js&"
export * from "./UserMenuInfo.vue?vue&type=script&lang=js&"
import style0 from "./UserMenuInfo.vue?vue&type=style&index=0&id=15c9981b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c9981b",
  null
  
)

export default component.exports